const getCurrentProject = (companies, companyId, projectId) => {
    const company = companies?.find(c => c.id === companyId);
    const project = (company?.projects ?? []).find(p => p.id === projectId);
    return project;
}

export default getCurrentProject;